import { useEffect } from 'react';
import { sendSettingsScreenLoadedEvent } from 'utils/analytics-events';

interface UseCustomerSupportReturn {
  // Add any business logic return values here if needed in the future
}

export const useCustomerSupport = (): UseCustomerSupportReturn => {
  useEffect(() => {
    sendSettingsScreenLoadedEvent('customer support');
  }, []);

  return {};
};
